var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconCheck48Line = function SvgIconCheck48Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.45 33.2h-.06a2.912 2.912 0 0 1-2.07-.931l-7.56-8.17 2.49-2.31 7.21 7.78L34.8 15.29l2.4 2.41-14.71 14.65a2.86 2.86 0 0 1-2.04.85Z",
    fill: "current"
  })));
};
export default SvgIconCheck48Line;